var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.72054 7.14844V4.72266C8.72054 4.27609 9.08257 3.91406 9.52914 3.91406H19.2323C19.6788 3.91406 20.0409 4.27609 20.0409 4.72266V16.043C20.0409 16.4896 19.6788 16.8516 19.2323 16.8516H16.8065V19.2766C16.8065 19.7236 16.4427 20.0859 15.9924 20.0859H6.30031C5.85067 20.0859 5.48633 19.7264 5.48633 19.2766L5.48843 7.95774C5.48851 7.51078 5.85233 7.14844 6.30254 7.14844H8.72054ZM7.10547 8.76562L7.10367 18.4688H15.1893V8.76562H7.10547ZM10.3377 7.14844H16.8065V15.2344H18.4237V5.53125H10.3377V7.14844Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.1cc4298814e355ae4aa5d3880d5a102d.svg";
export { ForwardRef as ReactComponent };